import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=73cf4198&scoped=true"
import script from "./StepHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=73cf4198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cf4198",
  null
  
)

export default component.exports